import { ArrowRightOutlined, UserOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { ServiceOrderStatusTag } from '@models';
import { OrderChange } from '@services';
import { serviceOrderChangeDateParser } from '@utils';
import { Avatar, Col, Row, Typography } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;

interface IProps {
  changes: OrderChange[];
  /** The build's log mixes several jobs together, so each entry has to say which one it is on. */
  showOrderTitle?: boolean;
}

/**
 * The change-log entries themselves - who changed what, and from what to what.
 *
 * Pulled out of OrderChangeShared so the same rendering serves both a single job's History tab and
 * the build's unified log, which only differ in whether each entry needs its job's name on it and
 * in where the list of changes comes from.
 */
export const OrderChangeList: React.FC<IProps> = ({ changes, showOrderTitle }) => (
  <>
    {changes.map((orderChange) => {
      const fromRange = serviceOrderChangeDateParser(orderChange.from);
      const toRange = serviceOrderChangeDateParser(orderChange.to);
      const creationTime = dayjs.utc(orderChange.creationTime);
      const creationLocal = creationTime.local().format('MMMM DD, YYYY h:mm A');

      return (
        <Row key={orderChange.id}>
          <Col span={24}>
            <Row gutter={8}>
              <Col>
                <Avatar style={{ background: '#0891B2' }} icon={<UserOutlined />} />
              </Col>
              <Col>
                <b>{orderChange.user.fullname}</b> changed the <b>{orderChange.type}</b>{' '}
                {showOrderTitle && orderChange.order?.title && (
                  <>
                    on <b>{orderChange.order.title}</b>{' '}
                  </>
                )}
                {creationLocal}
              </Col>
            </Row>
          </Col>
          <Col offset={2} style={{ marginTop: -5, marginBottom: 10 }}>
            {orderChange.type === 'Workstation' ? (
              <Row gutter={4}>
                <Col>
                  {orderChange.from ? <Text>{orderChange.from}</Text> : <Text>{L('Unassigned')}</Text>}
                </Col>
                <Col>
                  <ArrowRightOutlined />
                </Col>
                <Col>
                  {orderChange.to ? <Text>{orderChange.to}</Text> : <Text>{L('Unassigned')}</Text>}
                </Col>
              </Row>
            ) : orderChange.type === 'Status' ? (
              <Row gutter={4}>
                <Col>{ServiceOrderStatusTag[orderChange.from as never]}</Col>
                <Col style={{ marginLeft: -6 }}>
                  <ArrowRightOutlined />
                </Col>
                <Col>{ServiceOrderStatusTag[orderChange.to as never]}</Col>
              </Row>
            ) : orderChange.type === 'Technician' ? (
              <Row gutter={4}>
                <Col>
                  {orderChange.from ? <Text>{orderChange.from}</Text> : <Text>{L('Unassigned')}</Text>}
                </Col>
                <Col>
                  <ArrowRightOutlined />
                </Col>
                <Col>
                  {orderChange.to ? <Text>{orderChange.to}</Text> : <Text>{L('Unassigned')}</Text>}
                </Col>
              </Row>
            ) : orderChange.type === 'Date' ? (
              <Row gutter={4}>
                <Col>
                  <Text>{fromRange || L('Unassigned')}</Text>
                </Col>
                <Col>
                  <ArrowRightOutlined />
                </Col>
                <Col>
                  <Text>{toRange || L('Unassigned')}</Text>
                </Col>
              </Row>
            ) : (
              <></>
            )}
          </Col>
          <br />
        </Row>
      );
    })}
  </>
);

export default OrderChangeList;
